// ─── TotalsTable ──────────────────────────────────────────────────────────────
//  Tabela reutilizável com linha de "Total Geral" somando as colunas marcadas
//  como `total: true`. Pensada para ser usada em qualquer módulo que precise
//  de uma listagem tabular com totalizador.
//
//  columns: [{ key, label, align, render(row), value(row) => number, total, totalFormatter }]
//  rows:    array de objetos de dados
//  C:       tema (card, border, text, muted)

export function TotalsTable({ columns, rows, rowKey, totalLabel = "Total Geral", C, onRowClick, selectedKey }) {
  const totals = columns.map((col) => {
    if (!col.total) return null;
    return rows.reduce((acc, row) => {
      const v = col.value ? col.value(row) : row[col.key];
      return acc + (Number(v) || 0);
    }, 0);
  });

  const cellStyle = (align) => ({
    padding: "10px 14px",
    textAlign: align || "left",
    fontSize: 13,
    color: C.text,
    whiteSpace: "nowrap",
  });

  return (
    <div style={{
      background: C.card, border: `1px solid ${C.border}`,
      borderRadius: 14, overflowX: "auto",
    }}>
      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 560 }}>
        <thead>
          <tr style={{ borderBottom: `1px solid ${C.border}` }}>
            {columns.map((col) => (
              <th
                key={col.key}
                style={{
                  ...cellStyle(col.align),
                  fontSize: 11, fontWeight: 700, color: C.muted,
                  textTransform: "uppercase", letterSpacing: "0.05em",
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={columns.length} style={{ padding: "24px 14px", textAlign: "center", color: C.muted, fontSize: 13 }}>
                Nenhum registro encontrado.
              </td>
            </tr>
          )}
          {rows.map((row) => {
            const key = rowKey(row);
            const selected = onRowClick && key === selectedKey;
            return (
              <tr
                key={key}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                style={{
                  borderBottom: `1px solid ${C.border}`,
                  cursor: onRowClick ? "pointer" : "default",
                  background: selected ? `${C.brand || "#7C3AED"}18` : "transparent",
                }}
              >
                {columns.map((col) => (
                  <td key={col.key} style={cellStyle(col.align)}>
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
        {rows.length > 0 && (
          <tfoot>
            <tr style={{ borderTop: `2px solid ${C.border}` }}>
              {columns.map((col, i) => (
                <td key={col.key} style={{ ...cellStyle(col.align), fontWeight: 800 }}>
                  {i === 0
                    ? totalLabel
                    : col.total
                      ? (col.totalFormatter ? col.totalFormatter(totals[i]) : totals[i])
                      : ""}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
